import { cloneDeep, isEqual } from "lodash-es";
import { Dimensions } from "appRoot/app.constants";
import moment from "moment";
import { TableDragService } from "app/services/tableDrag/TableDrag.service";
import { PositioningServiceInstance } from 'app/services/serviceNamePositioning/ServiceNamePositioning.service';
import ObjectCopyService from "external-services/object-copy-service/index";
import TimelineService from "app/services/timeline/timeline.service";
import ViewActionsService, {
  EDIT_BOOKING_CLOSED, EDIT_BOOKING_OPENED, EDIT_CUSTOMER_CLOSED, EDIT_CUSTOMER_OPENED
} from 'app/actions/view.actions';
import { NEW_BOOKING_CLOSED, NEW_BOOKING_OPENED } from 'app/actions/newBooking.actions';
import { BookingStatusNames } from "shared-types/index";
import { StatusService } from "external-services/status-service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import BookingIntervalService from "app/services/bookingInterval/bookingInterval.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import DateUtilsService from 'external-services/date-utils-service';
import LoginActions from "app/actions/login.actions";
import VenueActions, { VenueActionNames } from "app/actions/venue.actions";
import PouchActions, { PouchDocType } from "app/actions/pouch.actions";
import BookingLookupService from "external-services/booking-lookup-service";
import PouchSyncService from "external-services/pouch-sync-service/index";
import { showDragBookingConfirmDialog } from "app/bookings/timeList/dragBookingConfirm/showDragBookingConfirmDialog";
import { FormatAlignJustifyTwoTone } from "@material-ui/icons";
import store from 'appRoot/Store';
import { rootDisplayActions } from 'app/reducers/display/slice';
import { layoutActions } from 'app/reducers/layout/slice';

// requiring html templates so that hot reloading works
const template = require('./bookingsTimeList.html');

const NS = 'BookingsTimeList'; // jshint ignore:line

/**
 * when the timeline has more bookings than this it can start to have performance issues and needs to be optimised for
 * to maintain usability.
 */
const TABLET_PERFORMANCE_LIMIT = 100;

export default function BookingsTimeList(
  $log, $rootScope, $window, $document, $mdDialog, $timeout, $filter,
  bookingsCalulationsService, unregister
) {
  "ngInject";

  return {
    restrict: 'E',
    controllerAs: 'tbList',
    template,
    scope: {
      date: '<',
      bookings: '<',
      schedule: '<',
      services: '<',
      bookingsByTable: '<',
      section: '<',
      selectedSectionIds: '<',
      createNewBlockout: '<',
      quickBlockoutsCtrl: '<',
      defaultSectionLayouts: '<',
      layouts: '<',
      layoutLookUp: '<',
      isFocused: '<',
      showBlockoutNotification: '<'
    },
    controller,
    link
  };

  function controller($rootScope, $scope, $element, scheduleService, bookingsCalulationsService) {
    "ngInject";

    const vm = this;
    let serviceWatch;
    let bookingsWatch;
    let sectionIdWatch;
    let sectionsLookup;
    //-- define public properties
    vm.minuteLength = 3; // 2px for every min
    vm.tables = [];
    vm.rowHeight = 30;
    vm.TableLabel = "";
    vm.TimeLabel = "";
    vm.PosiRight = -10000;
    vm.gridHover = gridHover;
    vm.PosiLeft = -10000;
    vm.getBookingZIndex = getBookingZIndex;
    // vm.cancelPromise;
    // vm.hideToolTip;
    vm.tableLookUp = {};
    vm.sectionLookUp = {};
    vm.scrollLeft = 0;
    vm.bottomPadding = 30;
    vm.scheduleBookingIntervals = [];
    vm.coversBookingIntervals = [];
    //-- define public methods
    vm.newBookingAt = newBookingAt;
    vm.newBookingAtTime = newBookingAtTime;
    vm.gridHoverHide = gridHoverHide;

    vm.getBookingsClass = getBookingsClass;
    vm.Pos = "";
    vm.gridHover = gridHover;
    vm.selectService = selectService;
    vm.getTablePosition = getTablePosition;
    vm.getMinOfDay = getMinOfDay;
    vm.checkOverDue = checkOverDue;
    vm.blockEvent = blockEvent;
    vm.getSectionLayoutLabel = getSectionLayoutLabel;
    vm.getMarkerColor = getMarkerColor;
    vm.verticallyAlignOverlappingLabels = verticallyAlignOverlappingLabels;
    //-- listen
    vm.listeners = [];
    vm.listeners.push($scope.$watch('schedule', updateSchedule));
    vm.listeners.push(PouchActions.handlePouchSyncedDoctype(PouchDocType.blockout, () => updateBlockouts()));
    vm.listeners.push($scope.$watch('createNewBlockout', checkNewBlockout));
    vm.listeners.push($scope.$watch('bookings', bookingsChange));

    vm.listeners.push(
      PouchActions.handlePouchSyncedDoctype(PouchDocType.booking, (evt, ids) => bookingChange(ids))
    );

    vm.editingBooking = false;
    vm.listeners.push($rootScope.$on(EDIT_BOOKING_OPENED, () => {
      vm.editingBooking = true;
    }));
    vm.listeners.push($rootScope.$on(NEW_BOOKING_OPENED, () => {
      vm.editingBooking = true;
    }));
    vm.listeners.push($rootScope.$on(EDIT_CUSTOMER_OPENED, () => {
      vm.editingBooking = true;
    }));

    vm.listeners.push($rootScope.$on(EDIT_BOOKING_CLOSED, (evt, { payload }) => {
      if (payload.isHardClose) {
        vm.editingBooking = false;
      }
    }));
    vm.listeners.push($rootScope.$on(NEW_BOOKING_CLOSED, () => {
      vm.editingBooking = false;
    }));
    vm.listeners.push($rootScope.$on(EDIT_CUSTOMER_CLOSED, (evt, { payload }) => {
      if (payload.isHardClose) {
        vm.editingBooking = false;
      }
    }));

    //-- init
    setHeaderOffsetsForDragAndDropCalc();
    getSectionsLookUp();
    getGeneralSettings();
    updateBlockouts();
    async function bookingChange(updatedBookingIds) {

      if (updatedBookingIds.length === 1) {
        // if only 1 booking has been updated, don't re-render everything if it is just a quick edit
        const updatedBookingId = updatedBookingIds[0];
        let originalBooking = getOriginalBooking(updatedBookingId);

        let newBooking;
        try {
          newBooking = await BookingLookupService.getById(updatedBookingId, $scope.date);
        } catch (err) {
          console.warn(NS, `error retrieving booking by id "${updatedBookingId}".`);
        }

        if (newBooking) {
          const containsOnlyQuickChanges = PouchSyncService.containsOnlyQuickChanges(originalBooking, newBooking, true);
          if (containsOnlyQuickChanges) {
            updateCoversIndicator();
          }
        }
      }
    }

    /**
     * NBI-9351: The TimelineService.getFromTable method needs to know the height of the header and time bar
     * to calculate the correct table from the row you drag from. So we get it from the DOM instead of hardcoding it,
     * like the old code did. Hardcoding is fragile because it breaks if the header or time bar is changed.
     */
    function setHeaderOffsetsForDragAndDropCalc() {
      const timeBarOffsetElement = document.querySelector('[data-time-bar-offset-element]');
      if (timeBarOffsetElement) {
        store.dispatch(layoutActions.setTimeBarHeight(timeBarOffsetElement.offsetHeight));
      }
      const headerOffsetElement = document.querySelector('[data-header-offset-element]');
      if (headerOffsetElement) {
        // use the header's bottom edge rather than its own height so anything rendered
        // above it (e.g. the COR-100 deprecation banner) is included in the drag offset
        store.dispatch(layoutActions.setHeaderHeight(headerOffsetElement.getBoundingClientRect().bottom));
      }
    }

    function getOriginalBooking(id) {
      let originalBooking = vm.allBookings.find(b => b._id === id);
      if (originalBooking) {
        return cloneDeep(originalBooking); // needs to be a clone so booking object isn't affected by mutation
      }
      return null;
    }

    function updateCoversIndicator() {

      vm.scheduleBookingIntervals = bookingsCalulationsService.getScheduleIntervalsWithCovers($scope.schedule, $scope.layouts, vm.tables, $scope.bookingsByTable);
      vm.bookingIntervals = vm.scheduleBookingIntervals;
      updateCoversByType();
    }

    function updateCoversByType() {
      vm.totalBookingIntervals = [];
      if (vm.sections && vm.generalSettings?.enableMaxOccupancy) {
        // get covers interval based on one minute slices
        const _coversBookingIntervalsByMinute = vm.allTimes ? BookingIntervalService.getCoversPerMinuteInterval(cloneDeep(vm.allTimes), $scope.bookings, vm.sections) : [];
        vm.coversBookingIntervalsByMinute = _coversBookingIntervalsByMinute.filter(val => val.coversTotal > 0);
        vm.sections.forEach((section) => {
          const bookingInterval = BookingIntervalService.getBookingIntervalBasedOnType(vm.coversBookingIntervalsByMinute, section._id); // get array of intervals based on type of occupancy in each section
          section.bookingInterval = bookingInterval;
          vm.totalBookingIntervals.push(bookingInterval); // Use it to show the Top Max Occupancy bar which turns Yellow if any of the Section breaches Max Occupancy
        });
        vm.totalBookingIntervals = [].concat.apply([], vm.totalBookingIntervals); // Merge/Flatten array of arrays
      }
    }

    function updateSchedule(value) {
      vm.optimiseTimelineBookings = false;
      if (value) {
        vm.loadingSchedule = true;
        vm.startMinute = null;
        vm.serviceLookup = {};
        for (var i = $scope.schedule.services.length - 1; i >= 0; i--) {
          var service = $scope.schedule.services[i];
          vm.serviceLookup[service._id] = service;
        }

        $scope.newBlockoutSelections = false;
        removeSettingsWatch();
        addSettingsWatch();
        updateBlockouts();
      }
    }

    function calulateTimeline() {
      var intervalMarkers = [];
      var min = vm.startHour * 60;
      var totalMins = vm.endHour * 60;
      const timezoneId = AdminService.getVenueTimezoneId();
      var intervalDate = DateUtilsService.getClearDate($scope.date, timezoneId);
      intervalDate.setMinutes(min);
      // loop over the times and create an interval every 15 mins
      for (min; min <= totalMins; min += 15) {
        var minOfDay = DateUtilsService.minsBetweenDates($scope.date, intervalDate);
        var intervalTime = cloneDeep(intervalDate);
        var position = (minOfDay - (vm.startHour * 60)) * vm.minuteLength;
        intervalMarkers.push({
          time: intervalTime,
          label: (intervalTime.getMinutes() === 0) ? $filter('date')(intervalTime, 'ha') :
            (intervalTime.getMinutes() === 30) ? $filter('date')(intervalTime, 'h:mm') : '',
          position: position
        });

        intervalDate.setMinutes(intervalDate.getMinutes() + 15);
      }
      vm.intervalMarkers = intervalMarkers;

      vm.totalBookingIntervals = [];

      if (vm.generalSettings?.enableMaxOccupancy && vm.intervalMarkers && vm.intervalMarkers.length > 0) {
        vm.allTimes = DateUtilsService.getTimesBetweenStartAndEndTimes(vm.intervalMarkers[0].time, vm.intervalMarkers.slice(-1)[0].time, 1);
      }
    }

    function getMarkerColor(interval, section) {
      //returns the type of occupancy based on interval and section - used in html
      return interval.coversBySection && interval.coversBySection.get(section._id) ? interval.coversBySection.get(section._id).sectionMarker : '';
    }

    function bookingsChange(value) {
      if (value) {
        /**
         * counts bookings that are rendered on the timeline and determines if there are enough to enter "optimisedTimeline" mode,
         * where bookings are only fully rendered when in the view port.
         */
        const visibleBookings = value.filter(b => b.status && b.status.name !== (BookingStatusNames.Cancelled || BookingStatusNames.CancelledNoShow));
        vm.optimiseTimelineBookings = visibleBookings.length > TABLET_PERFORMANCE_LIMIT;

        if (vm.loadingSchedule && visibleBookings <= TABLET_PERFORMANCE_LIMIT) {
          vm.loadingSchedule = false;
        }

        setTimeout(() => {
          /**
           * Using `vm.allBookings` in timeout to render in HTML, instead of `$scope.bookings` directly, so that the
           * `vm.loadingSchedule` has a chance to render.
           */
          /* use of sorted array to allow a correct overlapping of bookings based on date ordering */
          let sortedValue = value.sort(function (a, b) { return a.time - b.time; })
          vm.allBookings = sortedValue;
          vm.allBookings.forEach((booking, index) => {
            booking.bookingIndex = index;
          });
          vm.loadingSchedule = false;
          updateTimeLine();
          verticallyAlignOverlappingLabels();
        }, 0);
      } else {
        vm.allBookings = [];
        vm.loadingSchedule = false;
      }
    }


    function updateBlockouts() {
      if (!$scope.schedule) {
        console.log(NS, `$scope.schedule not ready yet. Can't update blockouts on it.`)
        return;
      }
      // new code block - Instead of refreshing only the blockout data it goes for refreshing the blockous that belong to current day service (BLOCKOUT FIXING)
      scheduleService.addBlockouts($scope.schedule, $scope.date).then(function (schedule) {
        $scope.schedule = schedule;
        console.log("[BLOCKOUT UPDATE] - Refreshing grid");
        calculateBlockoutsPos();
      });
    }

    function checkNewBlockout(value) {
      if (!value && vm.sections && vm.tableBySection) {
        for (var i = vm.sections.length - 1; i >= 0; i--) {
          var section = vm.sections[i];
          if (section) {
            section.selected = false;
            var tables = vm.tableBySection[section._id];
            for (var t = tables.length - 1; t >= 0; t--) {
              var table = tables[t];
              table.selected = false;
            }
          }
        }
        if (vm.intervalMarkers) {
          for (var m = vm.intervalMarkers.length - 1; m >= 0; m--) {
            var intervalMarkers = vm.intervalMarkers[m];
            intervalMarkers.selected = false;
          }
        }
      }
    }

    function getSectionLayoutLabel(sectionLayout) {
      var str = '<span class="service-name" status="active">' + sectionLayout.name + '</span>';
      var service = vm.serviceLookup[sectionLayout.serviceId];
      if (!sectionLayout.sectionOpen) {
        str += '<span class="note closed-section" status="close">Section Closed</span>';
      } else {
        if ($scope.layoutLookUp && sectionLayout && sectionLayout.layoutId) {
          var notesParts = [];
          if (service.type === 'event' && service.eventType && service.eventType === 'PrivateFunction') {
            notesParts.push(service.people + ' people');
          }
          var layout = $scope.layoutLookUp[sectionLayout.layoutId];
          if (layout) {
            notesParts.push(layout.name);
          }
          if (notesParts.length) {
            str += '<span class="note" status="active">' + notesParts.join(', ') + '</span>';
          }
        }
      }
      return str;
    }

    /**
     * Aligns the labels, once they are rendered on the page.
     * The label list (i.e. schedule.serviceLayouts) loads the closed section labels after some delay.
     * Hence, aligning the labels after every 300 ms to make sure all the labels have rendered till then.
     */
    function verticallyAlignOverlappingLabels() {

      let timesRun = 0;
      var interval = setInterval(() => {
        timesRun += 1;
        // Clear the timer after 1.5 secs
        if (timesRun === 5) {
          clearInterval(interval);
        }
        computeLabelsAlignment();
      }, 300);
    }

    /**
     * Detect overlap and then, separate the labels by aliging them vertically within a section
     */
    function computeLabelsAlignment() {

      // if floorplan or runsheet are visible, this shouldn't run
      if (!$scope.isFocused) return;

      // Get all the service labels present on the page for a specific day
      const allServiceLabels = $element[0].getElementsByClassName("service-name");

      // Sort the labels as per the section's position (top-to-bottom) on the page i.e. Dining room, Bar, etc.
      const serviceLayoutLabels = Array.from(allServiceLabels).sort(PositioningServiceInstance.sortServiceLayoutLabelList);

      // Contains the index of the service labels which are already aligned
      let alreadyAlignedLabels = [];

      // Iterate through each label
      for (let i = 0; i < serviceLayoutLabels.length; i++) {

        // Align only those labels which are not previously aligned
        if (!alreadyAlignedLabels.includes(i)) {

          // Sum of the total space occupied by the service and layout label in pixels within a section
          let totalAreaOccupiedByLabels = 0;

          // Contains the index of overlapped service labels
          let overlapLabelList = [];

          const { offsetParent } = serviceLayoutLabels[i];
          const sectionHeight = offsetParent?.offsetHeight || 0;
          const labelWithLargestWidth = serviceLayoutLabels[i].getBoundingClientRect();
          const overlapArea = labelWithLargestWidth.x + labelWithLargestWidth.width;

          /*
           * Determine the area to be occupied by the service (e.g. All Day Service) and layout (e.g. Dining Room) labels together within a sub-section once separated.
           * Steps to calculate the total occupied space:
           * 1. Retrieve the label, overlapping at a single position by their own left (x-coordinate) and parent's top position
           * 2. Add the height of all the overlapped service and layout labels
           * 3. Repeat step 1, until no overlapping label exist
           */
          for (let j = i; j < serviceLayoutLabels.length; j++) {

            // Overlapped labels have their own left position and their parent's top position as same
            const { x } = serviceLayoutLabels[j].getBoundingClientRect();

            if (Math.floor(x) >= Math.floor(labelWithLargestWidth.x) && Math.floor(x) <= Math.floor(overlapArea) && (
              offsetParent && serviceLayoutLabels[j].offsetParent && // fixed error: Uncaught TypeError: Cannot read properties of null (reading 'offsetTop')
              offsetParent.offsetTop === serviceLayoutLabels[j].offsetParent.offsetTop
            )) {

              totalAreaOccupiedByLabels = PositioningServiceInstance.determineAreaOccupiedByLabels(totalAreaOccupiedByLabels, serviceLayoutLabels[j]);

              // Append the index to get the count of the overlapped service labels
              overlapLabelList.push(j);

              // Append the index to not iterate again for this label
              alreadyAlignedLabels.push(j);
            }
          }

          totalAreaOccupiedByLabels = totalAreaOccupiedByLabels + PositioningServiceInstance.calculateMinimumFreeSpace(overlapLabelList.length);

          // Make AccomodationInfo
          const accomodationInfo = {
            Labels: serviceLayoutLabels,
            OverlapLabelList: overlapLabelList,
            SectionHeight: sectionHeight
          }

          // Do not reduce the font size of the labels, when the total occupied area is less than the available section height
          if (totalAreaOccupiedByLabels > sectionHeight) {
            totalAreaOccupiedByLabels = PositioningServiceInstance.accomodateLabelsWithinSection(accomodationInfo);
          }

          const totalAvailableFreeSpace = sectionHeight - (totalAreaOccupiedByLabels - PositioningServiceInstance.calculateMinimumFreeSpace(overlapLabelList.length));
          const freeSpaceBetweenEachLabel = totalAvailableFreeSpace / (overlapLabelList.length + 1);

          // Make AlignmentInfo
          const alignmentInfo = {
            Labels: serviceLayoutLabels,
            OverlapLabelList: overlapLabelList,
            FreeSpaceBetweenEachLabel: freeSpaceBetweenEachLabel
          }

          PositioningServiceInstance.alignOverlappingLabels(alignmentInfo);
        }
      }
    }

    function blockEvent(evt) {
      evt.stopPropagation();
      return false;
    }

    function getMinOfDay(time) {
      return DateUtilsService.getMinOfDay($scope.date, time);
    }

    function getTablePosition(tableId, booking) {
      if (vm.tableLookUp[tableId]) {
        var tableDetails = vm.tableLookUp[tableId];
        var pos = tableDetails.startPos;
        if (booking && tableDetails.bookingsPos[booking._id]) {
          pos += tableDetails.bookingsPos[booking._id];
        }
        return pos;
      } else {
        return -vm.rowHeight;
      }
    }

    function getBookingZIndex(bookingIndex) {
      const returnIndex = ((vm.allBookings.length - 1) - bookingIndex) < 0
        ? 0
        : ((vm.allBookings.length - 1) - bookingIndex);

      return returnIndex;
    }

    function getBookingsClass(booking) {
      for (var i = $scope.schedule.services.length - 1; i >= 0; i--) {

        var serviceItem = $scope.schedule.services[i];

        if (booking.serviceId === serviceItem._id) {

          if (serviceItem.Colour) {
            if (serviceItem.Colour.includes("#") || serviceItem.Colour.includes("(")) {
              return "booking-time";
            }
            return serviceItem.Colour;
          }
        }
      }


      return "booking-time";
    }


    function getSectionsLookUp() {
      SectionLookupService.getSectionsLookUp().then(function (sections) {
        sectionsLookup = sections;

        calculateLayoutPos();
      }).catch(function (err) {
        $log.error('error getSectionsLookUp', err);
      });
    }

    function addSettingsWatch() {
      serviceWatch = $scope.$watchCollection(() => $scope.services, updateService);
      bookingsWatch = $scope.$watch('bookings', updateBookings);

      sectionIdWatch = $scope.$watch('section', calculateLayoutPos);
    }

    function removeSettingsWatch() {
      if (serviceWatch) {
        serviceWatch();
      }
      if (bookingsWatch) {
        bookingsWatch();
      }
      if (sectionIdWatch) {
        sectionIdWatch();
      }
    }

    function updateService(value, oldValue) {
      if (value !== null && !isEqual(value, oldValue) && oldValue !== undefined) {
        updateTimeLine();
      }
    }

    function bookingsHaveChanged(newBookingList, oldBookingList) {
      if (!oldBookingList) {
        return true;
      }
      const newIds = newBookingList.map(b => b._rev).join(',');
      const oldIds = oldBookingList.map(b => b._rev).join(',');
      return newIds === oldIds;
    }

    function updateBookings(value, oldValue) {
      // @todo: see if this could be sped up on large venues by checking just the revision id. Something like the 'bookingsHaveChanged' function below. severity: low
      // if (value && oldValue !== undefined && bookingsHaveChanged(value, oldValue)) {

      if (value && !isEqual(value, oldValue) && oldValue !== undefined) {
        checkOverDue();
        calculateLayoutPos();
      }
    }

    function getGeneralSettings() {
      GeneralSettingsService.get().then(function (settings) {
        vm.generalSettings = settings;
        checkOverDue();
      });
    }

    function checkOverDue() {
      var isToday = false;
      if (vm.generalSettings && vm.generalSettings.highlightOverdue) {
        const timezoneId = AdminService.getVenueTimezoneId();
        if ($scope.date && DateUtilsService.isDateToday($scope.date, timezoneId)) {
          isToday = true;
        }
        if (isToday && $scope.bookings) {
          var timeNow = DateUtilsService.getVenueTime(timezoneId);
          var minNow = (timeNow.getHours() * 60) + timeNow.getMinutes();
          var totalBookings = $scope.bookings.length;
          for (var i = totalBookings - 1; i >= 0; i--) {
            var booking = $scope.bookings[i];
            booking.overdue = false;
            if (!booking.status) {
              StatusService.populateMissingStatusInBooking(booking);
            }
            if (booking.status.statusType === 'unconfirmed' || booking.status.statusType === 'confirmed' || booking.status.statusType === 'pending-payment') {
              // the booking has not been seated yeat
              var bookingMinOverDue = ($scope.tbList.getMinOfDay(booking.time) + vm.generalSettings.highlightOverdueMins);
              if (bookingMinOverDue < minNow) {
                booking.overdue = true;
              }
            }
          }
        }
      }
    }

    function selectService(serviceId) {
      $scope.$emit('select-service-id', serviceId);
    }

    /**
     * Gets the earliest start time in a list of services
     */
    function getEarliestStartTime(services) {
      return moment.min(services.map(s => moment(s.startTime))).toDate();
    }

    /**
     * Gets the latest end time in a list of services
     */
    function getLatestEndTime(services) {
      return moment.max(services.map(s => moment(s.endTime))).toDate();
    }

    function updateTimeLine() {

      if ($scope.schedule) {
        var sericesStart = $filter('orderBy')($scope.schedule.services, 'startTime');
        var sericesEnd = $filter('orderBy')($scope.schedule.services, 'endTime');
        var openTime = sericesStart[0].startTime;
        var closeTime = sericesEnd[sericesEnd.length - 1].endTime;
        if ($scope.services && $scope.services.length) {
          openTime = getEarliestStartTime($scope.services);
          closeTime = getLatestEndTime($scope.services);
        }

        var bookingByEndDate = $filter('orderBy')($scope.bookings, 'bookingEnd', true);
        if (bookingByEndDate) {
          var lastBooking = bookingByEndDate[0];
          if (lastBooking && lastBooking.bookingEnd.getTime() > closeTime.getTime()) {
            closeTime = lastBooking.bookingEnd;
          }

        }
        vm.startHour = openTime.getHours();
        vm.totalHours = DateUtilsService.hoursBetweenDates(openTime, closeTime) + 3;
        vm.endHour = vm.startHour + vm.totalHours;
        var orgStartMin = vm.startMinute;
        vm.startMinute = (vm.startHour * 60);
        if (orgStartMin === vm.startMinute) {
          // vm.startMinuteUpdate(vm.startMinute)
        }
        vm.endMinute = (vm.totalHours * 60);
        calucateServiceGaps();
        calculateBlockoutsPos();
        calulateTimeline();
        calculateLayoutPos();
      }
    }

    function calucateServiceGaps() {
      var serviceGaps = [];
      var lastSectionsLookUp = {};
      var serviceLayouts = $filter('orderBy')($scope.schedule.serviceLayouts, 'startTime');
      for (var i = 0; i < serviceLayouts.length; i++) {
        var serviceLayout = serviceLayouts[i];
        var lastServiceLayout = lastSectionsLookUp[serviceLayout.sectionId];
        if (lastServiceLayout) {
          if (lastServiceLayout.endTime.getTime() < serviceLayout.startTime.getTime()) {
            // added code to test the service is used
            if (!serviceLayout.sectionNotUsed) {
              serviceGaps.push({
                sectionId: serviceLayout.sectionId,

                startMin: lastServiceLayout.endMin,
                endMin: serviceLayout.startMin,
                totalMin: (serviceLayout.startMin - lastServiceLayout.endMin)
              });
            }
          }
        }
        lastSectionsLookUp[serviceLayout.sectionId] = serviceLayout;
      }
      vm.serviceGaps = serviceGaps;
    }

    function calculateBlockoutsPos() {
      var sericesStart = $filter('orderBy')($scope.schedule.services, 'startTime');
      var sericesEnd = $filter('orderBy')($scope.schedule.services, 'endTime');
      var openTime = sericesStart[0].startTime;
      var closeTime = sericesEnd[sericesEnd.length - 1].endTime;
      // calucate blockouts min
      for (var b = $scope.schedule.blockouts.length - 1; b >= 0; b--) {
        var blockout = $scope.schedule.blockouts[b];
        if (blockout.startDateTime.getTime() < openTime.getTime()) {
          blockout.startMin = vm.startMinute;
        } else {
          blockout.startMin = DateUtilsService.minsBetweenDates($scope.date, blockout.startDateTime);

        }
        if (blockout.endDateTime.getTime() > closeTime.getTime()) {
          blockout.endMin = vm.startMinute + vm.endMinute;
        } else {
          blockout.endMin = DateUtilsService.minsBetweenDates($scope.date, blockout.endDateTime);

        }
        blockout.totalMin = (blockout.endMin - blockout.startMin);
        if (blockout.totalMin < 0) {
          blockout.totalMin = 0;
        }
      }
    }

    function checkServiceActive() {
      for (var s = $scope.schedule.services.length - 1; s >= 0; s--) {
        let service = $scope.schedule.services[s];
        const allSelected = !$scope.services || !$scope.services.length;
        const isActive = allSelected ? true
          : $scope.services.some(s => {
            return isEqual(s.sectionLayouts, service.sectionLayouts);
          });
        service = { ...service, active: isActive };
        // console.log('service', service)
      }
    }

    function getUniqueSections(sectionlst) {
      const uniqueSections = Array.from(new Set(sectionlst.map(a => a.layoutId)))
        .map(layoutId => {
          return sectionlst.find(a => a.layoutId === layoutId)
        });

      return uniqueSections;
    }


    function calculateLayoutPos() {
      if ($scope.schedule && $scope.bookings && sectionsLookup) {
        const sectionLayoutsFull = ($scope.services && $scope.services.length)
          ? $scope.services.reduce((acc, s) => (acc.concat(s.sectionLayouts)), [])
          : $scope.defaultSectionLayouts;

        const sectionLayouts = getUniqueSections(sectionLayoutsFull);
        checkServiceActive();

        // get the layouts by id
        var layoutsIds = [];
        var sectionLayoutLookUp = {};
        for (var i = 0; i < sectionLayouts.length; i++) {
          var sectionLayout = sectionLayouts[i];
          // limit the section if one is selected
          if ((!$scope.selectedSectionIds || $scope.selectedSectionIds.indexOf(sectionLayout.sectionId) !== -1)) {
            layoutsIds.push(sectionLayout.layoutId);
            sectionLayoutLookUp[sectionLayout.sectionId] = sectionLayout.layoutId;
          }
        }

        LayoutsService.getByLayouts(layoutsIds, $scope.date).then(function (results) {
          var tablesList = results.tablesArray;
          vm.tables = $filter('alphaSortFilter')(tablesList, 'name');
          // group tables in to sections
          var tableBySection = {};
          var sections = [];
          var sectionIdLookUp = {};
          var table;

          var totalTablesAdded = 0;
          for (var i = 0; i < vm.tables.length; i++) {
            table = vm.tables[i];
            if (!tableBySection[table.sectionId]) {
              tableBySection[table.sectionId] = [];
              sections.push(sectionsLookup[table.sectionId]);
              sectionIdLookUp[table.sectionId] = sections.length;
            }
            tableBySection[table.sectionId].push(table);
            totalTablesAdded++;
          }
          var tableLookUp = {};
          var sectionLookUp = {};
          var tableStartPos = 0;
          sections = $filter('orderBy')(sections, 'order');
          for (var v = 0; v < sections.length; v++) {
            var section = sections[v];
            if (section) {
              var sectionId = section._id;
              sectionLookUp[sectionId] = {};
              sectionLookUp[sectionId].layoutId = sectionLayoutLookUp[sectionId];
              sectionLookUp[sectionId].top = tableStartPos;
              sectionLookUp[sectionId].height = 0;
              // add the section
              tableStartPos += vm.rowHeight;
              var tables = tableBySection[sectionId];
              for (var t = 0; t < tables.length; t++) {
                table = tables[t];
                var tableHeight = vm.rowHeight;
                var tableBookingsPos = {};
                // test if table is shared
                if (table.shared) {
                  var tableBookingsList = ($scope.bookingsByTable && $scope.bookingsByTable[table._id]) ? $scope.bookingsByTable[table._id].bookings : [];
                  var tableBookings = $filter('orderBy')(tableBookingsList, 'time');
                  // array for put bookings in to check conflicts
                  var filledArray = TimelineService.calculateSharedTableVerticalBookingPosition(tableBookings, $scope.date);
                  // if length is 0 make sure the height is at least 1 row
                  tableHeight = vm.rowHeight * (filledArray.length || 1);
                  // calculate the height of the booking
                  filledArray.forEach((item, index) => {
                    item.forEach((booking) => {
                      tableBookingsPos[booking._id] = index * vm.rowHeight;
                    });
                  });
                }
                tableLookUp[table._id] = {
                  startPos: tableStartPos,
                  bookingsPos: tableBookingsPos,
                  height: tableHeight,
                  table: table
                };
                tableStartPos += tableHeight;
                sectionLookUp[sectionId].height += tableHeight;
              }
            }
          }
          vm.tableLookUp = tableLookUp;
          vm.sectionLookUp = sectionLookUp;
          vm.sections = sections;
          vm.tableBySection = tableBySection;
          if (vm.updateSizes) {
            vm.updateSizes();
          }
          vm.bookingHeight = (tableStartPos + vm.bottomPadding);
          updateCoversIndicator();
          vm.loadingSchedule = false;
        }).catch(function (err) {
          $log.warn('err', err);
          vm.loadingSchedule = false;
        });
      }
    }

    // this function works out which to highlight for tables and times.
    function gridHover(evt) {
      var headerTimes = document.querySelectorAll('*[id^="TimeIndexer_"]');

      headerTimes.forEach(function (element) {
        element.classList.remove("bookings-table-list-overlay");
      });

      var timeInMins = vm.startMinute + ((evt.offsetX) / vm.minuteLength);

      var table = false;
      for (var tableId in vm.tableLookUp) {
        var tablePos = vm.tableLookUp[tableId];
        const tableEl = document.getElementById(tablePos.table._id);
        if (tableEl) {
          tableEl.classList.remove("bookings-time-list-overlay");
        }
        if (evt.offsetY >= tablePos.startPos && evt.offsetY < (tablePos.startPos + tablePos.height)) {
          table = tablePos.table;
        }
      }

      var date = new Date($scope.date);
      var hours = Math.floor(timeInMins / 60);
      var minutes = Math.floor(timeInMins - (hours * 60));
      date.setHours(hours);
      date.setMinutes(minutes);
      if (table != null && table._id != null) {
        const tableEl = document.getElementById(table._id);
        if (tableEl) {
          tableEl.classList.add("bookings-time-list-overlay");
        }
      }

      var el = document.getElementById("TimeIndexer_" + hours + "" + (Math.floor((minutes / 15)) * 15));

      if (el != null) {
        el.classList.add("bookings-table-list-overlay");
      }
    }

    /* jshint ignore:start */

    // could be usedfull in future
    function formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    /* jshint ignore:end */


    function gridHoverHide(evt) {
      vm.gridHoverHide = true;

    }

    function callAtTimeout() {
      vm.hideToolTip = true;
    }


    function newBookingAtTime(evt) {
      vm.hideToolTip = false;
      $timeout.cancel(vm.cancelPromise);
      switch (evt.which) {
        case 1:

          var timeInMins = vm.startMinute + ((evt.offsetX) / vm.minuteLength);

          var table = false;
          for (var tableId in vm.tableLookUp) {
            var tablePos = vm.tableLookUp[tableId];

            if (evt.offsetY >= tablePos.startPos && evt.offsetY < (tablePos.startPos + tablePos.height)) {
              table = tablePos.table;

            }
          }

          var date = new Date($scope.date);
          var hours = Math.floor(timeInMins / 60);
          var minutes = Math.floor(timeInMins - (hours * 60));
          date.setHours(hours);
          date.setMinutes(minutes);
          if (table != null && table._id != null) {

            var markers = (Math.floor((minutes / 15)) * 15);
            if (markers === 0) {
              markers = "00";
            }
            date.setMinutes(markers);
            vm.TableLabel = "T" + table.name + " @ " + $filter('date')(date, 'h:mm');
            vm.PosiLeft = evt.offsetX + 6;
            vm.PosiRight = evt.offsetY - 26;
            vm.cancelPromise = $timeout(callAtTimeout, 1300);
          }
          break;

        case 2:
          vm.PosiLeft = -1000;
          vm.PosiRight = -1000;
          break;
        case 3:
          vm.PosiLeft = -1000;
          vm.PosiRight = -1000;
          vm.hideToolTip = true;
          break;
        default:
          vm.PosiLeft = -1000;
          vm.PosiRight = -1000;
          vm.hideToolTip = true;
          break;
      }


    }


    function newBookingAt(evt) {
      vm.PosiLeft = -1000;
      vm.PosiRight = -1000;
      $timeout(function () {

        vm.hideToolTip = true;

      }, 370);
      if (!vm.dragging) {
        var timeInMins = vm.startMinute + ((evt.offsetX) / vm.minuteLength);
        var date = new Date($scope.date);
        var hours = Math.floor(timeInMins / 60);
        var minutes = Math.floor(timeInMins - (hours * 60));
        date.setHours(hours);
        date.setMinutes(minutes);
        var table = false;
        for (var tableId in vm.tableLookUp) {
          var tablePos = vm.tableLookUp[tableId];
          if (evt.offsetY >= tablePos.startPos && evt.offsetY < (tablePos.startPos + tablePos.height)) {
            table = tablePos.table;
          }
        }
        if (table) {
          $rootScope.$emit('new-booking-type-select', evt, date, table);
        }
      }
    }
  }

  function link(scope) { // warning this is not proper dependency injection like in controller. Arguments are same no matter what they are called.


    const vm = scope.tbList;
    let isTouchDevice = false; // until we get first touch event, then it'll be set to true
    let timeListPopoverTouchedTime = 0;
    const TIME_LIST_POPOVER_ALLOWANCE = 300;

    vm.startMinuteUpdate = startMinuteUpdate;

    let bookingTargetOffsetX;
    let bookingTargetOffsetY;
    let bookingDraging = false;
    let bookingDragEvt;
    let bookingsTimes = [];
    let dragBookingsTimes = [];
    let startBookingDragTimeout = null;
    let currentSecond;
    let propsToUpdate = [];
    let animateId;
    let bookinScrollId;

    scope.tbList.dragging = false;
    scope.tbList.dragBooking = {
      top: -100,
      left: 10,
      dragging: false
    };
    scope.tbList.dropBooking = {
      top: 10,
      left: 10
    };
    scope.tbList.checkBookingDrag = checkBookingDrag;
    scope.tbList.endBookingDrag = endBookingDrag;
    scope.tbList.showInfoAtTime = showInfoAtTime;
    scope.tbList.hideInfoAtTime = hideInfoAtTime;

    let lastPosition;
    let mousePostion;
    let bookingsMinOffeset = 0;
    let checkPositionTimeout = null;
    let viewHeight = 0;
    let startDragTarget;
    let scrollUpdateRequested;

    // define elements
    let bookingsTimeList = $window.document.getElementsByClassName('bookings-time-list')[0];
    const parentContainer = $window.document.getElementsByClassName('float-wrap')[0];
    let currentTimeMarkers = $window.document.getElementsByClassName('current-time-marker');
    let timeline = $window.document.getElementsByClassName('timeline')[0];
    let bookings = $window.document.getElementsByClassName('bookings')[0];
    let bookingsScroll = $window.document.getElementsByClassName('bookings-scroll')[0];
    let bookingsEl = angular.element(bookingsScroll);
    let bookingsScrollEl = angular.element(bookingsScroll);
    let tablesScroll = $window.document.getElementsByClassName('tables-scroll')[0];
    let tablesScrollEl = angular.element(tablesScroll);
    let timeScroll = $window.document.getElementsByClassName('time-scroll')[0];
    let timeScrollEl = angular.element(timeScroll);
    let time = $window.document.getElementsByClassName('time')[0];
    const timeEl = angular.element(time);
    let bookingsInfoWindow = $window.document.getElementsByClassName('bookings-info-window')[0];

    setViewReadyListeners();

    //-- watch
    // vm.listeners.push($rootScope.$on('venue-change', venueChange));
    vm.listeners.push(
      VenueActions.handleVenueAction(VenueActionNames.VENUE_CHANGE, () => venueChange())
    );
    // vm.listeners.push($rootScope.$on('logout', logout));
    LoginActions.handleLogout(() => logout());
    vm.listeners.push($rootScope.$on('rezise', updateSizes)); // @toDo 'resize' spelt wrong. Spell it right and check. severity: low
    vm.listeners.push(scope.$watch('schedule', scheduleUpdate));
    vm.listeners.push(scope.$watch('tbList.startMinute', startMinuteUpdate));
    vm.listeners.push(scope.$watch('service', serviceUpdate));
    vm.listeners.push(scope.$on('$destroy', destory));
    vm.listeners.push(scope.$watch('showBlockoutNotification', updateTimeLineHeight));

    // update the height of the timeline when the blockout notification is shown
    function updateTimeLineHeight(value) {
      updateSizes(value);
    }

    /**
     * Waits for bookings to load, or for 3 seconds to pass, which ever comes first.
     * Safari touch devices didn't work if the bookings were not loaded, as the DOM element is hidden at the point of
     * attaching the listener.
     */
    function setViewReadyListeners() {
      let viewReady = false;
      let viewReadyTimeout;
      // waits until bookings is set before setting listeners
      const unwatchBookings = scope.$watch('bookings', () => {
        if (scope.bookings && !viewReady) {
          unwatchBookings();
          $timeout.cancel(viewReadyTimeout);
          viewReady = true;
          setListenersOnViewReady();
        }
      });

      viewReadyTimeout = $timeout(() => {
        if (!viewReady) {
          unwatchBookings();
          $timeout.cancel(viewReadyTimeout);
          viewReady = true;
          console.warn(NS, 'setViewReadyListeners', '"scope.bookings" was not set. Timeline on Safari may not work with touch events.');
          setListenersOnViewReady();
        }
      }, 3000); // if bookings haven't loaded after 3 seconds, that's too bad. Add the listeners anyway.
    }

    function setListenersOnViewReady() {
      $window.addEventListener('resize', updateSizes);
      timeScrollEl?.on('touchstart', startDrag);
      bookingsScrollEl?.on('touchstart', startDrag);
      bookingsScrollEl?.on('touchmove', onBookingScroll);
      bookingsScrollEl?.on('touchend', onTouchEnd);
      timeScrollEl?.on('mousedown', startDrag);
      bookingsScrollEl?.on('mousedown', startDrag);
      bookingsScrollEl?.on('scroll', onBookingScroll);
      timeEl.on('mousemove', showInfoAtTime);
      timeEl.on('touchstart', showInfoAtTime);
      timeEl.on('touchmove', showInfoAtTime);
      timeEl.on('mouseleave', hideInfoAtTime);
      timeEl.on('touchend', hideInfoAtTime);
      bookingsScrollEl?.on('scroll', onBookingScroll);
    }

    function logout() {
      if (checkPositionTimeout) {
        $timeout.cancel(checkPositionTimeout);
      }
    }

    function venueChange() {
      if (checkPositionTimeout) {
        $timeout.cancel(checkPositionTimeout);
      }
    }

    function destory() {
      if (checkPositionTimeout) {
        $timeout.cancel(checkPositionTimeout);
      }

      unregister(vm.listeners);

      $window.removeEventListener('resize', updateSizes);
      timeScrollEl?.off('touchstart', startDrag);
      bookingsScrollEl?.off('touchstart', startDrag);
      bookingsScrollEl?.off('touchmove', onBookingScroll);
      bookingsScrollEl?.off('touchend', onBookingScroll);
      timeScrollEl?.off('mousedown', startDrag);
      bookingsScrollEl?.off('mousedown', startDrag);
      bookingsScrollEl?.off('scroll', onBookingScroll);

      timeEl.off('mousemove', showInfoAtTime);
      timeEl.off('touchstart', showInfoAtTime);
      timeEl.off('touchmove', showInfoAtTime);
      timeEl.off('mouseleave', hideInfoAtTime);
      timeEl.off('touchend', hideInfoAtTime);

      window.cancelAnimationFrame(animateId);
      window.cancelAnimationFrame(bookinScrollId);

      bookingsTimeList = null;
      currentTimeMarkers = null;
      timeline = null;
      bookings = null;
      bookingsEl = null;
      bookingsScroll = null;
      bookingsScrollEl = null;
      tablesScroll = null;
      tablesScrollEl = null;
      timeScroll = null;
      timeScrollEl = null;
      time = null;
      bookingsInfoWindow = null;
      currentTimeMarkers = null;
      startDragTarget = null;
      bookingDragEvt = null;
      propsToUpdate = null;
    }

    function animate() {
      if (propsToUpdate && propsToUpdate.length) {
        // consolidate updates
        var prosUpdated = {};
        for (var i = propsToUpdate.length - 1; i >= 0; i--) {
          var propToUpdate = propsToUpdate[i];
          var key = '' + propToUpdate.obj.id + propToUpdate.obj.className + propToUpdate.prop;
          if (!prosUpdated[key]) {
            prosUpdated[key] = true;
            propToUpdate.obj[propToUpdate.prop] = propToUpdate.value;
          }
        }
        propsToUpdate = [];
        draw();
      }

      window.cancelAnimationFrame(animateId);
      animateId = window.requestAnimationFrame(animate);
    }

    animate();

    function draw() {
      if (!scope.$$phase && currentSecond !== new Date().getSeconds()) {
        scope.$digest(function () {
          scope.autoUpdateTimer--;
        });
        currentSecond = new Date().getSeconds();
      }
    }

    function showInfoAtTime(evt) {

      if (!isTouchDevice && evt?.touches?.length) {
        isTouchDevice = true;
      }

      // sets the start time for click clicks
      if (isTouchDevice) {
        if (evt.type === "touchstart" && bookingsInfoWindow.style.display !== 'none') { // click again to close
          hideInfoAtTime();
          return;
        } else {
          timeListPopoverTouchedTime = Date.now();
        }
      }

      if (!scope.createNewBlockout) {
        scope.$evalAsync(function () {
          bookingsInfoWindow.style.display = 'block';
          bookingsInfoWindow.style.top = 40 + 'px';
          const xPos = getPointerX(evt);
          bookingsInfoWindow.style.left = (xPos - parentContainer.offsetLeft) + 'px';
          const timeXPos = (xPos + timeScroll.scrollLeft) - (timeScroll.offsetLeft + parentContainer.offsetLeft);
          const min = scope.tbList.startMinute + (timeXPos / scope.tbList.minuteLength);
          getInfoAtTime(min);
        });
      }
    }

    function getInfoAtTime(min) {
      const timezoneId = AdminService.getVenueTimezoneId();
      var timeNow = DateUtilsService.getVenueTime(timezoneId);
      var currentMin = (timeNow.getHours() * 60) + timeNow.getMinutes();

      scope.tbList.infoNow = bookingsCalulationsService.getBookingsCountAtMin(scope.date, min, scope.bookings, scope.schedule, currentMin);
    }

    function hideInfoAtTime(evt) {
      // ignore mouse events when touch detected
      if (isTouchDevice && evt?.type.indexOf('mouse') === 0) {
        return;
      }

      // if quickly tapped, keep the popover shown
      const diff = Date.now() - timeListPopoverTouchedTime;
      if (diff < TIME_LIST_POPOVER_ALLOWANCE) {
        timeListPopoverTouchedTime = 0;
        return;
      }

      bookingsInfoWindow.style.top = '-1000px';
      bookingsInfoWindow.style.left = '-1000px';
      bookingsInfoWindow.style.display = 'none';
    }

    function checkBookingDrag(evt, booking) {
      $document.off('touchend', updateBookingDrag);
      $document.on('touchend', endBookingDrag);
      $document.off('mouseup', endBookingDrag);
      $document.on('mouseup', endBookingDrag);

      if (startBookingDragTimeout) {
        $timeout.cancel(startBookingDragTimeout);
      }
      if (ManagerService.isManager || !booking.locked) {
        // check to see if the drag is allowed
        startBookingDragTimeout = $timeout(function () {
          startBookingDrag(evt, booking);
        }, 200);
      }
    }

    function getPointerY(evt) {
      const posObj = getPositionObject(evt);
      return posObj?.pageY;
    }

    function getPointerX(evt) {

      const posObj = getPositionObject(evt);
      return posObj?.pageX;
    }

    // cursor affects drag performance when there are a lot of bookings, so don't use it when busy
    function setDragCursor() {
      // removed drag icon completely as tables with huge joins also affect performance
      // $window.document.body.style.cursor = vm.showFancyCursor ? 'move' : 'default';
    }

    function startBookingDrag(evt, booking) {
      if (!booking.locked) {
        bookingDraging = true;
        setDragCursor();

        // select the element closest starting with 'booking-time' - Like booking-time-green. Earlier it was matching exact string 'booking-time'
        const bookingEl = evt.target.closest('[class*="booking-time"]');
        bookingTargetOffsetX = bookingEl ? getPointerX(evt) - bookingEl.getBoundingClientRect().x : 0;
        bookingTargetOffsetY = bookingEl ? getPointerY(evt) - bookingEl.getBoundingClientRect().y : 0;

        bookingDragEvt = evt;
        scope.tbList.dragBooking.width = scope.tbList.minuteLength * booking.duration;
        scope.tbList.dragBooking.booking = booking;

        if (bookingsTimes) {

          dragBookingsTimes = cloneDeep(bookingsTimes);
          var timesLookUp = dragBookingsTimes.map(function (time) {
            return time.toString();
          });
          var bookingTimeFound = timesLookUp.indexOf(scope.tbList.dragBooking.booking.time.toString());
          if (bookingTimeFound === -1) {
            dragBookingsTimes.push(scope.tbList.dragBooking.booking.time);
          }
        }
        dragBookingsTimes = $filter('orderBy')(dragBookingsTimes);
        $document.off('touchmove', updateBookingDrag);
        $document.on('touchmove', updateBookingDrag);

        $document.off('mousemove', updateBookingDrag);
        $document.on('mousemove', updateBookingDrag);
      }
    }

    function updateBookingDrag(evt) {
      let pageY = getPointerY(evt);
      let pageX = getPointerX(evt);
      if (!isNaN(pageX) && !isNaN(pageY)) {
        const timelineRect = timeline.getBoundingClientRect();
        const bookingsRect = bookings.getBoundingClientRect();
        scope.$evalAsync(function () {
          const top = pageY - bookingsRect.y - bookingTargetOffsetY;
          const left = pageX - timelineRect.x + bookingsScroll.scrollLeft - bookingTargetOffsetX;

          scope.tbList.dragBooking.dragging = true;
          propsToUpdate.push({
            obj: scope.tbList.dragBooking,
            prop: 'top',
            value: top
          });
          propsToUpdate.push({
            obj: scope.tbList.dragBooking,
            prop: 'left',
            value: left
          });

          checkDragScrollPos();
          updateBookingDrop();
          checkDropType();

          // do something that requires dirty checking of data
        });
      }
      evt.stopPropagation();
    }

    function checkDragScrollPos() {
      if (scope.tbList.dragBooking.dragging) {

        var move = false;
        var moveBy = 10;
        var scrollTop = bookingsScroll.scrollTop;
        var scrollLeft = bookingsScroll.scrollLeft;

        // test if the user is dragging left an we need to scroll
        if (scope.tbList.dragBooking.left < bookingsScroll.scrollLeft) {
          scrollLeft -= moveBy;
          move = true;
        }

        // test if the user is dragging right and we need to scroll
        var bookigRightEdge = scope.tbList.dragBooking.left + scope.tbList.dragBooking.width;
        var rightEdge = bookingsScroll.scrollLeft + bookingsScroll.clientWidth;
        if (bookigRightEdge > rightEdge) {
          scrollLeft += moveBy;
          move = true;
        }

        // test if the user needs to scroll down
        var bookigBottomEdge = scope.tbList.dragBooking.top + (vm.rowHeight * 2);
        var bottomEdge = bookingsScroll.scrollTop + bookingsScroll.clientHeight;
        if (bookigBottomEdge > bottomEdge) {
          scrollTop += moveBy;
          move = true;
        }

        // test to see if we need to scroll up.
        if (scope.tbList.dragBooking.top <= bookingsScroll.scrollTop) {
          scrollTop -= moveBy;
          move = true;
        }

        // Bookings area
        propsToUpdate.push({
          obj: bookingsScroll,
          prop: 'scrollTop',
          value: scrollTop
        });
        propsToUpdate.push({
          obj: bookingsScroll,
          prop: 'scrollLeft',
          value: scrollLeft
        });
        // Slaves areas
        propsToUpdate.push({
          obj: tablesScroll,
          prop: 'scrollTop',
          value: scrollTop
        });
        propsToUpdate.push({
          obj: timeScroll,
          prop: 'scrollLeft',
          value: scrollLeft
        });

        /**
         * @toDo This was a bit scary and not sure the reason behind it.
         * Condition does nothing and it makes call every 20ms to same function, in addition to the mousemove/touchmove event
         * severity: high
         */
        // if (move) {
        //   setTimeout(checkDragScrollPos, 20);
        // } else {
        //   setTimeout(checkDragScrollPos, 20);
        // }
      }
    }

    // Chrome on Windows touch screens didn't have a pageX property when touch event used, so used `targetTouches` instead or `changedTouches` (Android on touch end)
    function getPositionObject(evt) {
      if (evt.pageX) {
        return evt;
      }
      if (evt.targetTouches.length) {
        return evt.targetTouches[evt.targetTouches.length - 1];
      }
      if (evt.changedTouches.length) {
        return evt.changedTouches[evt.changedTouches.length - 1];
      }
      return null;
    }

    function removeMoveEndListeners() {
      $window.document.body.style.cursor = 'default';
      $document.off('touchmove', updateBookingDrag);
      $document.off('touchend', endBookingDrag);
      $document.off('mouseup', endBookingDrag);
      $document.off('mousemove', updateBookingDrag);
    }

    function endBookingDrag(evt) {
      $timeout.cancel(startBookingDragTimeout);

      if (bookingDraging) {
        evt.stopPropagation();
        bookingDraging = false;
        removeMoveEndListeners();

        const posObj = getPositionObject(evt);
        const isClickNotDrag = posObj && posObj.pageX === lastPosition.x && posObj.pageY === lastPosition.y;

        if (isClickNotDrag) {
          return;
        }

        // check that the drop position is valid
        if (scope.tbList.dropBooking.validTime && scope.tbList.dropBooking.table && scope.tbList.dropBooking.time && scope.tbList.dragBooking.booking) {
          var dragBooking = ObjectCopyService.angularSafeCopy(scope.tbList.dragBooking.booking);
          var swapWithBooking;
          var table = scope.tbList.dropBooking.table;
          var isError = TableDragService.checkForErrorWhileDraggingTables(dragBooking, table, scope.tbList.tables);
          var toTablesArray = !isError ? TableDragService.getConsecutiveTables(dragBooking, table, scope.tbList.tables) : [table];
          var fromTableArray = [];
          var dropBackOnSelf = false;
          var updateBooking = false;
          var tableBookingsList = (scope.bookingsByTable && scope.bookingsByTable[table._id]) ? scope.bookingsByTable[table._id].bookings : [];
          let isOverlap = false;
          let tableJoinSwapError = false;
          vm.hasSwappedTableChanged = false;

          if (!table.shared) {
            for (var i = tableBookingsList.length - 1; i >= 0; i--) {
              var booking = tableBookingsList[i];
              if (scope.tbList.dropBooking.time.getTime() === booking.time.getTime() && scope.tbList.dragBooking.booking._id === booking._id) {
                dropBackOnSelf = true;
              }
              // test to see if you are swaping with another booking
              if (scope.tbList.dropBooking.time.getTime() === booking.time.getTime() && scope.tbList.dragBooking.booking._id !== booking._id) {
                swapWithBooking = ObjectCopyService.angularSafeCopy(booking);
                isError = TableDragService.checkForErrorWhileDraggingTables(swapWithBooking, dragBooking.tables[0], scope.tbList.tables);
                fromTableArray = !isError ? TableDragService.getConsecutiveTables(swapWithBooking, dragBooking.tables[0], scope.tbList.tables) : dragBooking.tables;
                if (swapWithBooking.tables.length > 1 && dragBooking.tables.length > 1) {
                  tableJoinSwapError = true;
                }

                /**
                 * Do not show the modal when swapping booking on the same table.
                 * So, comparing the drag and drop booking tables to find the match.
                 */
                dropBackOnSelf = TableDragService.areSwappingBookingsOnSameTable(fromTableArray, toTablesArray);

                if (!dropBackOnSelf) {
                  if (swapWithBooking.tables.length > 1) {
                    toTablesArray = getAppropriateTable(swapWithBooking, dragBooking, toTablesArray[0]);
                  }
                  if (dragBooking.tables.length > 1) {
                    fromTableArray = getAppropriateTable(dragBooking, swapWithBooking, fromTableArray[0]);
                  }

                  /**
                   * Now swapping the bookings won't change the booking time so, there is a chance that the dragged/dropped table already has a booking for that time.
                   * In case of an overlap, show the overlap message in the swap modal.
                   * e.g.
                   * Swap Booking1(5:00PM - 5:30PM) from table T4 and Booking2(2:15PM - 3:30PM) from table T7.
                   * If table T4 already has a Booking3(2:00PM - 3:30PM), then
                   * show "This move will overlap a booking on a table, select move if you would like to proceed" message in the swap modal.
                   */

                  // Check overlap for dragged booking
                  isOverlap = TableDragService.isOverlapBooking(scope.bookingsByTable, toTablesArray, dragBooking, booking, true);

                  // Check overlap for dropped booking
                  if (!isOverlap) {
                    isOverlap = TableDragService.isOverlapBooking(scope.bookingsByTable, fromTableArray, booking, dragBooking, true);
                  }
                }
              }
            }
          }

          /**
           * Check overlap, only if bookings are not swapped.
           * We are already checking the overlap for swap bookings in the above code.
           */
          if (!swapWithBooking && !isOverlap) {
            isOverlap = TableDragService.isOverlapBooking(scope.bookingsByTable, toTablesArray, dragBooking, scope.tbList.dropBooking, false);
          }

          // update the booking if you have not dragged back on the the same position
          if (!dropBackOnSelf) {
            updateBooking = true;
          }

          if (updateBooking) {
            var fromTable = scope.tbList.dragBooking.fromTable;

            showDragBookingConfirmDialog({
              dialogShowFn: $mdDialog.show,
              isFloorPlanV2: false,
              toTable: table,
              toTablesArray: toTablesArray,
              fromTable: fromTable,
              fromTableArray: fromTableArray,
              newTime: scope.tbList.dropBooking.time,
              schedule: scope.schedule,
              dragBooking: ObjectCopyService.angularSafeCopy(dragBooking),
              swapWithBooking: (swapWithBooking) ? ObjectCopyService.angularSafeCopy(swapWithBooking) : swapWithBooking,
              isError: isError,
              isOverlap: isOverlap,
              layouts: scope.layouts,
              tableJoinSwapError: tableJoinSwapError,
              allTimes: vm.allTimes,
              hasSwappedTableChanged: vm.hasSwappedTableChanged,
              tableName: vm.tableName,
              fulfilledCb: () => {
                clearBookingDrag();
                if (swapWithBooking) {
                  store.dispatch(rootDisplayActions.showToastFullOptions({
                    msg: `Tables swapped.`,
                    isCleanStyle: true,
                  }))
                  setTimeout(() => {
                    store.dispatch(rootDisplayActions.clearToast())
                  }, 3000);
                }
              },
              cancelledCb: clearBookingDrag
            });

          } else {
            // the drop position is not valid
            clearBookingDrag();
          }
        } else {
          // the drop position is not valid
          clearBookingDrag();
        }
      }
      bookingDraging = false;
    }


    /**
     * Assigns most appropriate table based on pax requirement
     */
    function getAppropriateTable(toBooking, fromBooking, swappedWithTable) {

      const tablesArray = TableDragService.getAppropriateTable(toBooking, fromBooking);

      // Show a message to the user when the swapped table has changed.
      vm.hasSwappedTableChanged = swappedWithTable._id !== tablesArray[0]._id ? true : false;
      vm.tableName = `T${tablesArray[0].name}`;

      return tablesArray;
    }

    function clearBookingDrag() {
      scope.tbList.dragBooking = {
        top: -100,
        dragging: false
      };
    }

    function calulateBookingsTimes() {
      var boookingInterval = scope.schedule.boookingInterval;
      var sericesStart = $filter('orderBy')(scope.schedule.services, 'startTime');
      var startDate = sericesStart[0].startTime;
      // create a list of possible booking times
      bookingsTimes = [];
      // work out the total time
      for (var s = 0; s < scope.schedule.services.length; s++) {
        var service = scope.schedule.services[s];
        var serviceStartDate = service.startTime;
        var serviceStartMin = DateUtilsService.dateTimeNum(startDate, serviceStartDate);
        var serviceEndTimeDate = service.endTime;
        var serviceEndTimeMin = DateUtilsService.dateTimeNum(startDate, serviceEndTimeDate);
        var totalTimes = Math.floor((serviceEndTimeMin - serviceStartMin) / boookingInterval) + 1;
        for (var i = 0; i < totalTimes; i++) {
          var time = new Date(serviceStartDate.getTime());
          var minsToAdd = i * boookingInterval;
          time.setMinutes(time.getMinutes() + minsToAdd);
          time.setSeconds(0);
          time.setMilliseconds(0);
          bookingsTimes.push(time);
        }
      }
    }

    /**
     * Update the marker that shows where the booking will be placed on drop
     */
    function updateBookingDrop() {
      // find what table the drag is over. Use the middle
      var yPos = scope.tbList.dragBooking.top + (vm.rowHeight / 2);
      var dropY = -100;

      for (var tableId in scope.tbList.tableLookUp) {
        var tableDetails = scope.tbList.tableLookUp[tableId];
        var pos = tableDetails.startPos;

        if (yPos > pos && yPos < (pos + tableDetails.height)) {
          dropY = pos;
          scope.tbList.dropBooking.table = tableDetails.table;
          break;
        }
      }

      scope.tbList.dropBooking.top = dropY;
      // find the closet booking interval
      var posInMins = (scope.tbList.dragBooking.left / scope.tbList.minuteLength) + scope.tbList.startMinute;
      var position = false;

      if (dragBookingsTimes) {
        // a time has been passed it select the closet interval to that time
        for (var i = 1; i < dragBookingsTimes.length; i++) {
          var timeBefore = dragBookingsTimes[i - 1];
          var timeAfter = dragBookingsTimes[i];
          var timeBeforeMin = DateUtilsService.minsBetweenDates(scope.date, timeBefore); // (timeBefore.getHours() * 60) + timeBefore.getMinutes();
          var timeAfterMin = DateUtilsService.minsBetweenDates(scope.date, timeAfter);
          if (posInMins < timeAfterMin) {
            var diffToBefore = posInMins - timeBeforeMin;
            var diffToAfter = timeAfterMin - posInMins;
            if (diffToBefore < diffToAfter) {
              position = (timeBeforeMin - scope.tbList.startMinute) * scope.tbList.minuteLength;
              scope.tbList.dropBooking.time = timeBefore;
            } else {
              position = (timeAfterMin - scope.tbList.startMinute) * scope.tbList.minuteLength;
              scope.tbList.dropBooking.time = timeAfter;
            }
            break;
          }
        }
      }

      scope.tbList.dropBooking.left = (position === false) ? -1000 : position;
      scope.tbList.dropBooking.validTime = (position === false) ? false : true;
    }

    function checkDropType() {
      var dropType = 'move';
      if (scope.tbList.dropBooking.validTime && scope.tbList.dropBooking.table && scope.tbList.dropBooking.time && scope.tbList.dragBooking.booking) {
        var table = scope.tbList.dropBooking.table;
        // check to see if you are dropping on a booking
        var tableBookingsList = (scope.bookingsByTable && scope.bookingsByTable[table._id]) ? scope.bookingsByTable[table._id].bookings : [];

        if (!table.shared) {
          for (var i = tableBookingsList.length - 1; i >= 0; i--) {
            var booking = tableBookingsList[i];
            if (scope.tbList.dropBooking.time.getTime() === booking.time.getTime()) {
              if (scope.tbList.dragBooking.booking._id === booking._id) {
                dropType = 'keep';
              } else {
                dropType = 'swap';
              }
            }
          }
        }

      }
      scope.tbList.dropBooking.type = dropType;
    }

    function onBookingScroll(evt) {
      if (bookingDraging) {
        evt.preventDefault();
        return;
      }

      if (!scrollUpdateRequested) {
        scrollUpdateRequested = true;
        window.cancelAnimationFrame(doonBookingScroll);
        bookinScrollId = window.requestAnimationFrame(doonBookingScroll);

        ViewActionsService.onTimelineScrollChanged();
      }
    }

    function onTouchEnd(evt) {
      endDrag(); // stops mouse drag triggering after a touch drag has finished

      // detects if 'touchstart' coords were within specified 'pixel allowance', then cancels drag and replaces with click
      const pixelAllowance = 10;
      const isClicked = touchEndAsClick(evt, pixelAllowance, lastPosition.x, lastPosition.y);
      if (isClicked) {
        clickBookingAndCancelDrag(evt.target, lastPosition.x, lastPosition.y);
      } else {
        // otherwise treat as a normal drag
        onBookingScroll(evt);

        // stops booking hanging around for until next refresh (up to 10 seconds) when dropped on invalid drop point
        $timeout(() => {
          scope.tbList.dragBooking.dragging = false;
        }, 0);
      }
    }

    function doonBookingScroll() {
      if (!scope.tbList.dragging && !bookingDraging) {
        //var maxOffSet = scope.tbList.bookingHeight - viewHeight;
        // if (bookingsScroll.scrollTop > maxOffSet) {
        //     bookingsScroll.scrollTop = maxOffSet;
        // }
        tablesScroll.scrollTop = bookingsScroll.scrollTop;
        timeScroll.scrollLeft = bookingsScroll.scrollLeft;
      }
      scope.tbList.scrollLeft = bookingsScroll.scrollLeft;
      scrollUpdateRequested = false;
    }

    function startDrag(evt) {
      startDragTarget = angular.element(evt.target);

      // only hides the popup if touching somewhere other than the time scroller
      if (evt?.touches?.length && !startDragTarget.closest('.time-scroll')?.length) {
        hideInfoAtTime();
      }

      const posObj = getPositionObject(evt);

      lastPosition = {
        x: posObj.pageX,
        y: posObj.pageY
      };

      // setFromTable(posObj.pageY);
      const fromTable = TimelineService.getFromTable(posObj.pageY, bookingsScroll.scrollTop, scope.tbList.tableLookUp);
      if (fromTable && scope.tbList?.dragBooking) {
        scope.tbList.dragBooking.fromTable = fromTable;
      }

      /**
       * cancels further scroll/pan movement on the timeline if the target is a booking, so that the booking
       * can be dragged without the scroll happening at the same time.
       */
      const targetIsBooking = startDragTarget.hasClass('booking') || startDragTarget.closest('.booking').length > 0;
      if (targetIsBooking && evt.cancelable) {
        evt.preventDefault();
        return;
      }

      removeDragListeners(startDragTarget);
      addDragListeners(startDragTarget);
    }


    function addDragListeners(target) {
      target.on('mouseleave', endDrag);
      target.on('mousemove', updatePostion);
      target.on('mouseup', endDrag);
    }

    function removeDragListeners(target) {
      target.off('mouseleave', endDrag);
      target.off('mousemove', updatePostion);
      target.off('mouseup', endDrag);
    }

    function endDrag() {
      $window.document.body.style.cursor = 'default';
      removeDragListeners(startDragTarget);
      scope.tbList.dragging = false;
    }

    function updatePostion(evt) {
      if (startBookingDragTimeout) {
        $timeout.cancel(startBookingDragTimeout);
      }
      scope.tbList.dragging = true;
      setDragCursor();
      mousePostion = {
        x: evt.pageX,
        y: evt.pageY
      };
      var movementX = mousePostion.x - lastPosition.x;
      var movementY = mousePostion.y - lastPosition.y;
      if (bookingDraging) {
        movementX = 0;
        movementY = 0;
      }
      var bookingsScrollScrollTop = (bookingsScroll.scrollTop - movementY);
      var bookingsScrollScrollLeft = (bookingsScroll.scrollLeft - movementX);
      var maxOffSet = scope.tbList.bookingHeight - viewHeight;
      if (bookingsScrollScrollTop > maxOffSet) {
        bookingsScrollScrollTop = maxOffSet;
      }
      lastPosition = mousePostion;

      propsToUpdate.push({
        obj: bookingsScroll,
        prop: 'scrollTop',
        value: bookingsScrollScrollTop
      });
      propsToUpdate.push({
        obj: bookingsScroll,
        prop: 'scrollLeft',
        value: bookingsScrollScrollLeft
      });
      propsToUpdate.push({
        obj: tablesScroll,
        prop: 'scrollTop',
        value: bookingsScrollScrollTop
      });
      propsToUpdate.push({
        obj: timeScroll,
        prop: 'scrollLeft',
        value: bookingsScrollScrollLeft
      });

      // prevents drag lag on large venues
      evt.stopPropagation();
    }

    // update scroll sizing
    function updateSizes(isNotification = false) {
      if (bookingsTimeList && bookingsTimeList.offsetParent) {
        const notificationTopOffset = isNotification ? 64 : 0; // blockout notification height
        // 64 = header height; add the COR-100 deprecation banner shown above it (0 when absent)
        const offsetTop = notificationTopOffset + 64 + Dimensions.bannerHeight;

        const docHeight = document.documentElement.clientHeight;
        const docWidth = document.documentElement.clientWidth;

        viewHeight = (docHeight - (offsetTop + time.clientHeight));
        bookingsScroll.style.height = viewHeight + 'px';
        bookingsScroll.style.width = (docWidth - bookingsTimeList.offsetLeft) + 'px';
        timeScroll.style.width = (docWidth - bookingsTimeList.offsetLeft) + 'px';
        tablesScroll.style.height = (viewHeight) + 'px';
        timeline.style.height = (viewHeight + time.clientHeight) + 'px';
        bookingsMinOffeset = -(viewHeight - (vm.tables.length) * vm.rowHeight);
      }
    }

    function updateTimeMarkers(scrollTo) {
      const timezoneId = AdminService.getVenueTimezoneId();
      var timeNow = DateUtilsService.getVenueTime(timezoneId);
      var currentMin = (timeNow.getHours() * 60) + timeNow.getMinutes();
      var position;
      var isToday = false;
      currentTimeMarkers = $window.document.getElementsByClassName('current-time-marker');

      if (scope.schedule) {
        var sericesEnd = $filter('orderBy')(scope.schedule.services, 'endTime');
        var lastService = sericesEnd[sericesEnd.length - 1];
        var serviceEndDate = lastService.endTime;
        var serviceEndMin = DateUtilsService.dateTimeNum(scope.date, serviceEndDate);

        if (scope.date && DateUtilsService.isDateToday(scope.date, timezoneId)) {
          isToday = true;
        }
        for (var i = currentTimeMarkers.length - 1; i >= 0; i--) {
          position = (scope.tbList.minuteLength * (currentMin - scope.tbList.startMinute));
          if (currentMin < serviceEndMin && isToday) {
            currentTimeMarkers[i].style.left = position + 'px';
            currentTimeMarkers[i].style.display = 'block';
          } else {
            currentTimeMarkers[i].style.display = 'none';
            currentTimeMarkers[i].style.left = '-1px';
          }
        }
      }

      if (scrollTo === true) {
        var scrollPos = (position - (30 * scope.tbList.minuteLength));
        if (!isNaN(scrollPos) && bookingsScroll && !isNaN(bookingsScroll.scrollLeft)) {
          scrollTo = false;
          bookingsScroll.scrollLeft = scrollPos;
          if (isNaN(bookingsScroll.scrollLeft) || (bookingsScroll.scrollLeft === 0 && scrollPos > 0)) {
            scrollTo = true;
          }
        }
      }

      if (isToday) {
        var updateTime = 1000 * 10;
        if (currentTimeMarkers.length === 1 || scrollTo) {
          updateTime = 300;
        }
        scope.tbList.checkOverDue();
        if (checkPositionTimeout) {
          $timeout.cancel(checkPositionTimeout);
        }
        checkPositionTimeout = $timeout(function () {
          updateTimeMarkers(scrollTo);
        }, updateTime);
      }
    }

    function scheduleUpdate() {
      if (scope.schedule) {
        calulateBookingsTimes();
      }
    }

    function startMinuteUpdate(value) {
      if (value) {
        setUpMarkers();
      }
    }

    function serviceUpdate(value, oldValue) {
      if (oldValue !== undefined) {
        $timeout(updateTimeMarkers, 200);
      }

      if (scope.services && scope.services.length) {
        if (oldValue !== null || oldValue !== undefined) {
          propsToUpdate.push({
            obj: bookingsScroll,
            prop: 'scrollLeft',
            value: 0
          });
        }
      }
    }

    function clearTimeMarkers() {
      for (var i = currentTimeMarkers.length - 1; i >= 0; i--) {
        currentTimeMarkers[i].style.display = 'none';
        currentTimeMarkers[i].style.left = '-1px';
      }
      propsToUpdate.push({
        obj: bookingsScroll,
        prop: 'scrollLeft',
        value: 0
      });
    }

    function setUpMarkers() {
      const timezoneId = AdminService.getVenueTimezoneId();
      if (scope.date && DateUtilsService.isDateToday(scope.date, timezoneId)) {
        updateTimeMarkers(true);
      } else {
        clearTimeMarkers();
      }
    }

    /**
     * Treats 'touchend' event as a click, with an optional forgiving 'pixelAllowance' if fingers move a little
     * @param {*} evt - 'touchend' event object
     * @param {*} pixelAllowance - set to 0 if not using it
     * @param {*} prevX - x coord from 'touchstart' event
     * @param {*} prevY - y coord from 'touchstart' event
     */
    function touchEndAsClick(evt, pixelAllowance, prevX, prevY) {
      pixelAllowance = pixelAllowance || 0;

      const touchObj = evt.originalEvent.changedTouches[0];
      if (pixelAllowance) {
        return isPointWithinAllowance(pixelAllowance, touchObj.pageX, touchObj.pageY, prevX, prevY);
      } else {
        return prevX === touchObj.pageX && prevY === touchObj.pageY;
      }
    }

    /**
     * Checks if current X/Y is within a forgiving 'pixelAllowance' if fingers move a little
     * @param {*} pixelAllowance
     * @param {*} curX
     * @param {*} curY
     * @param {*} prevX
     * @param {*} prevY
     */
    function isPointWithinAllowance(pixelAllowance, curX, curY, prevX, prevY) {
      const halfPxAll = Math.ceil(pixelAllowance / 2);
      const minX = prevX - halfPxAll;
      const maxX = prevX + halfPxAll;
      const isWithinAllowanceX = curX >= minX && curX <= maxX;
      const minY = prevY - halfPxAll;
      const maxY = prevY + halfPxAll;
      const isWithinAllowanceY = curY >= minY && curY <= maxY;

      return isWithinAllowanceX && isWithinAllowanceY;
    }


    /**
     * Cancels booking drag and triggers a click on it
     * @param {*} target - the booking element
     */
    function clickBookingAndCancelDrag(target, pageX, pageY) {
      $timeout.cancel(startBookingDragTimeout);
      clearBookingDrag();
      removeMoveEndListeners();
      bookingDraging = false;

      let evt = new jQuery.Event('click');

      // ensures we still send the click coords for the 'editPeople' and 'editStatus' buttons
      evt.pageX = pageX;
      evt.pageY = pageY;

      angular.element(target).trigger(evt);
    }

    // update size
    vm.updateSizes = updateSizes;
    updateSizes();
  }
}
